import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { DeliveryNote } from "src/app/_models";
import { DeliveryNoteService } from "src/app/_services";

@Component({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RouterModule,
    NgbDropdownModule,
    FontAwesomeModule,
    NgSelectModule,
  ],
  selector: "hawk-delivery-note-shipping",
  templateUrl: "./delivery-note-shipping.component.html",
  styleUrls: ["./delivery-note-shipping.component.scss"],
  host: {
    class: "app-page",
  },
})
export class DeliveryNoteShippingComponent implements OnInit {
  private fb = inject(FormBuilder);

  constructor(
    private deliveryNoteService: DeliveryNoteService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  public deliveryNoteId: number | String | string;
  public loadingPricing: boolean = false;
  public submittingLabel: boolean = false;
  public deliveryNote: DeliveryNote;
  public searchTerm: string = "";
  //angel_de, asendia, cargo_international, dhl, dhl_express, dpag, dpd, gls, go, hermes, iloxx, parcel_one, ups
  public carriersList: any[] = ["DHL", "dhl_express", "DPD", "UPS", "GO"];
  public shippingServices: any[] = [
    { id: "standard", name: "Standard" },
    { id: "one_day", name: "Express (1 day)" },
    { id: "one_day_early", name: "Express (1 day early)" },
  ];

  public deliveryNoteShippingForm = this.fb.group({
    width: this.fb.control<number>({ value: null, disabled: false }),
    height: this.fb.control<number>({ value: null, disabled: false }),
    length: this.fb.control<number>({ value: null, disabled: false }),
    weight: this.fb.control<number>({ value: null, disabled: false }),
    carrier: this.fb.control<string>({ value: null, disabled: false }),
    service: this.fb.control<string>({ value: null, disabled: false }),
    sender_phone: this.fb.control<string>({ value: null, disabled: false }),
    receiver_phone: this.fb.control<string>({ value: null, disabled: false }),
    email: this.fb.control<string>({ value: null, disabled: false }),
    description: this.fb.control<string>({ value: null, disabled: false }),
    direct_pickup: this.fb.control<boolean>(false),
    pickup_day: this.fb.control(null),
    pickup_start: this.fb.control("09:00"),
    pickup_end: this.fb.control("17:00"),
    saturday_delivery: this.fb.control(false),
    test: this.fb.control(false),
  });

  public calculatePrirce() {
    const formData = this.deliveryNoteShippingForm.value;
    const data = {
      width: formData.width,
      height: formData.height,
      length: formData.length,
      weight: formData.weight,
      service: formData.service,
      carrier: formData.carrier,
    };
    if (!Object.values(data).every((v) => v)) {
      let missingKey = "";
      if (!data.width) missingKey = "#width";
      if (!data.height) missingKey = "#height";
      if (!data.length) missingKey = "#length";
      if (!data.weight) missingKey = "#weighth";
      if (!data.service) missingKey = "#service";
      if (!data.carrier) missingKey = "#carrier";

      alert(`Das Feld '${missingKey}' muss ausgefüllt sein`);
    } else {
      this.loadingPricing = true;
      this.deliveryNoteService.calculateShippingPrice(this.deliveryNoteId, data).subscribe({
        next: (response) => {
          const element = document.getElementById("price_element");
          let price = null;
          if (response.success) {
            price = response.price;
          } else {
            price = "errors";
            alert(`error: ${response.message}`);
          }
          if (element) element.innerText = `${price}`;
          this.loadingPricing = false;
        },
        error: (error) => {
          alert(`error: ${error}`);
          const element = document.getElementById("price_element");
          if (element) element.innerText = `errors`;
          this.loadingPricing = false;
        },
      });
    }
  }

  public createShipping() {
    const formData = this.deliveryNoteShippingForm.value;
    this.submittingLabel = true;
    this.deliveryNoteService.createShipping(this.deliveryNoteId, formData).subscribe({
      next: () => {
        this.submittingLabel = false;
        this.router.navigate(["/", "lieferscheine", this.deliveryNote.id]);
      },
      error: (error) => {
        alert(`Errors: ${error}`);
        this.submittingLabel = false;
      },
    });
  }

  ngOnInit(): void {
    this.deliveryNoteId = parseInt(this.route.snapshot.paramMap.get("id"));
    this.loadDeliveryNote();
  }
  private loadDeliveryNote() {
    this.deliveryNoteService.show(this.deliveryNoteId).subscribe({
      next: (response: DeliveryNote) => {
        this.deliveryNote = response;
        this.deliveryNoteShippingForm.setValue({
          width: response.parcel_width,
          height: response.parcel_height,
          length: response.parcel_length,
          weight: response.parcel_weight,
          carrier: null,
          service: null,
          sender_phone: response.sender_phone,
          receiver_phone: response.receiver_phone,
          email: response.shipping_notification_email,
          description: response.parcel_description,
          direct_pickup: false,
          pickup_day: new Date(),
          pickup_start: "09:00",
          pickup_end: "17:00",
          saturday_delivery: false,
          test: false,
        });
      },
      error: (error) => {
        console.log("error", error);
      },
    });
  }
}
